import { render, staticRenderFns } from "./DeqDate.vue?vue&type=template&id=1a817c4a&scoped=true"
import script from "./DeqDate.vue?vue&type=script&lang=js"
export * from "./DeqDate.vue?vue&type=script&lang=js"
import style0 from "./DeqDate.vue?vue&type=style&index=0&id=1a817c4a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a817c4a",
  null
  
)

export default component.exports